export const STATUS_ATTENDANCE = 0;
export const STATUS_ABSENT = 1;
export const STATUS_ABSENT_JUSTIFIED = 2;
